import { createSlice, createAction } from '@reduxjs/toolkit';
import { defaultDomainReducers, defaultDomainState } from 'store/defaults';
import purge from 'store/purge';

export default createSlice({
  name: 'ASSETS_STATUS_DOMAIN',
  initialState: defaultDomainState,
  reducers: defaultDomainReducers,
  extraReducers: {
    ...purge(defaultDomainState),
  },
});

export const FETCH_ASSETS_STATUS = createAction('FETCH_ASSETS_STATUS');
